import React from "react";
import styled from "styled-components";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";
import { hexToRGBA } from "../../../../../utils/theme";

import TextInput from "../../../controls/TextInput";
import MaskInput from "../../../controls/MaskInput";
import Select from "../../../controls/Select";

const StyledContainer = styled.div`
  margin-bottom: 24px;
`;

const StyledRow = styled(Row)`
  margin-top: 1rem;
  margin-bottom: 2rem;
  margin-right: 0;
  margin-left: 0;
  padding: 16px;
  border: 2px solid #797c7f;
`;

function RepresentativeInfoBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <StyledContainer>
      <div className="inputs-block-title">
        <span>Representative/Executor Information</span>
      </div>
      <StyledRow>
        <Col xs={12} md={4}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.representativeFirstName)}
            label={getFieldProps(FORM_FIELD_KEYS.representativeFirstName)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.representativeFirstName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.representativeMiddleName)}
            label={getFieldProps(FORM_FIELD_KEYS.representativeMiddleName)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.representativeMiddleName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.representativeLastName)}
            label={getFieldProps(FORM_FIELD_KEYS.representativeLastName)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.representativeLastName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <Select
            {...getFieldProps(FORM_FIELD_KEYS.representativeTitle)}
            label={getFieldProps(FORM_FIELD_KEYS.representativeTitle)?.placeholder?.replace("*", "")}
            placeholder={getFieldProps(FORM_FIELD_KEYS.representativeTitle)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.representativeTitle]}
            validated={values.validated}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <Select
            {...getFieldProps(FORM_FIELD_KEYS.representativeSuffixName)}
            label={getFieldProps(FORM_FIELD_KEYS.representativeSuffixName)?.placeholder?.replace("*", "")}
            placeholder={getFieldProps(FORM_FIELD_KEYS.representativeSuffixName)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.representativeSuffixName]}
            validated={values.validated}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <MaskInput
            {...getFieldProps(FORM_FIELD_KEYS.representativeSSN)}
            label={(
              <>
                Social Security Number&nbsp;
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 0, hide: 0 }}
                  trigger={["hover", "click"]}
                  overlay={(
                    <Tooltip id={`tooltip-${FORM_FIELD_KEYS.representativeSSN}-subhint`} className="subhintTooltipFederal">
                      <span>
                        In order to assign an EIN for an Entity, the IRS requires the Social Security Number of the managing member. 
                        This information is secured with SSL encryption.
                      </span>
                    </Tooltip>
                  )}
                >
                  <a className="ssn-subhint-title">
                    Why is this needed?
                  </a>
                </OverlayTrigger>
              </>
            )}
            placeholder={getFieldProps(FORM_FIELD_KEYS.representativeSSN)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.representativeSSN]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            hideDivider
          />
        </Col>
      </StyledRow>
    </StyledContainer>
  );
}

export default RepresentativeInfoBlock;
